module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAATFJREFUOE9jZMAC/ltacn5nZRVh/POH6fOHD2/Frl37gq6MEVngh52d6s+/f32YGBjUGBgZmcBy/////8/IeJ+JiWkbz6FDl2Hq4Rq/2tj4/mNg8GZgYEAxDNlgRgaGg9xHjixnZGD4D1b02crKiYGJKRybs9HFmBkYdnAdObKe8Z2xMT87B0fzP0ZGdhTTpaU5mdjYmP7ev/8VRfP///9+MDA0M36xtHT/z8wcBJdkY2PimjDBkUlXVxkk9u/u3SffCwp2///w4Tdczf//exk/29hkMzAw6MEEOfLzdVhCQqyQbfmzd++FHw0Np2BiTIyMDxm/2NiU/2dgUIIJck2a5MhkaKiKrPHfvXtPv8XHb4WH6P//bymwkVw/kh2qZMcjzMNkpRyYZrLSKnLwE5M7AAAhpkbMxW0lAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/redIcon.png
// module id = I5/d
// module chunks = 1